import Car2RightGridContainer from "../../../components/car/grid/Car2RightGrid";

const Car2RightGrid = () => {
  return <Car2RightGridContainer />;
};

export default Car2RightGrid;
